export function normalizedLimit(value, maximum, fallback = 0) {
  const number = Number(value)
  return Number.isFinite(number) ? Math.max(0, Math.min(maximum, Math.round(number))) : fallback
}

export function hasCircuitBreakerLimits(positions, profit, loss) {
  return positions > 0 || profit > 0 || loss > 0
}

export function solLabel(lamports) {
  return lamports ? (lamports / 1e9).toFixed(3) + ' SOL' : 'Off'
}

export function autoConfirmPayload({ delayMs, breakerEnabled, maxPositions, profitLamports, lossLamports }) {
  return {
    delayMs: normalizedLimit(delayMs, 600000, 1000),
    autoStopMaxPositions: breakerEnabled ? normalizedLimit(maxPositions, 1000) : 0,
    autoStopProfitLamports: breakerEnabled ? normalizedLimit(profitLamports, 100_000_000_000) : 0,
    autoStopLossLamports: breakerEnabled ? normalizedLimit(lossLamports, 100_000_000_000) : 0,
  }
}
